import { createCsrfMiddleware, createStart } from "@tanstack/react-start"

import { sentryMiddleware } from "@/lib/sentry-middleware"
import { nightshiftRedirectMiddleware } from "@/lib/terminal/nightshift-redirect-middleware"

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
})

export const startInstance = createStart(() => ({
  requestMiddleware: [
    sentryMiddleware,
    nightshiftRedirectMiddleware,
    csrfMiddleware,
  ],
}))
